// Actions
export const APP_ERROR = Symbol.for('app.error')
export const SEARCH_QUERY = Symbol.for('app.searchQuery')
export const CLEAR_SEARCH = Symbol.for('app.clearSearch')
export const DONT_CLEAR = Symbol.for('app.dontClearSearch')
